export enum DateFilterOptionType {
  Last6Hours = '6h',
  Last12Hours = '12h',
  Last24Hours = '24h',
  Last2Days = '2d',
  Last7Days = '7d',
  Last2Weeks = '2w',
  Last30Days = '30d',
  Last90Days = '90d',
  Last1Month = '1M',
  Last3Months = '3M',
  Last6Months = '6M',
  Last1Year = '1y',
  SinceInception = 'sinceInception',
}

export interface DateFilterOptionLabel {
  id: DateFilterOptionType;
  label: string;
}

export enum BreakdownType {
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
}
